import { Redirect } from 'expo-router';
import Head from 'expo-router/head';

import { GiftCards } from '@fhs/payments';
import { GiftCardProvider } from '@fhs/payments/src/state/gift-card';
import { useFlag } from '@fhs-legacy/frontend/src/utils/launchdarkly';

export default function GiftCardsHomepage() {
  const enableGiftCards = useFlag('enable-fhs-gift-cards');

  if (!enableGiftCards) {
    return <Redirect href="/" />;
  }

  return (
    <>
      <Head>
        <title>Gift Cards - Firehouse Subs</title>
      </Head>
      <GiftCardProvider>
        <GiftCards />
      </GiftCardProvider>
    </>
  );
}
